import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicNetworkDnsDomainDetailsParamsRaw,
	type LWApiPublicNetworkDnsDomainDetailsResultRaw,
} from '@liquidweb-dev/club-sauce/public/network/dns/domain/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_DNS_DOMAIN_DETAILS_QUERY_KEY =
	'/network/dns/domain/details';

const useDomainDetails = (
	params: LWApiPublicNetworkDnsDomainDetailsParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicNetworkDnsDomainDetailsResultRaw,
		ApiErrorI
	>,
) => {
	return useQuery({
		queryKey: [NETWORK_DNS_DOMAIN_DETAILS_QUERY_KEY, params],
		queryFn: () => api.network.dns.domain.apiRaw.details(params),
		...options,
	});
};

export default useDomainDetails;
